module.exports = __webpack_public_path__ + "img/information-certificate.674c94db.jpg";